import { useState } from "react";
import styled from "@emotion/styled";
import { Flex, Text } from "styles/utility-components";

import { DetailsContent } from "components/app_layout/DetailsLayout";
import { CreateBidForm } from "components/bids/create_bid/CreateBidForm";
import { FilterableBids } from "components/bids/FilterableBids";
import { CreateEntityDrawer } from "components/entities/CreateEntityDrawer";
import Button from "components/ui/button/Button";
import CentredSpinner from "lib/core_components/CentredSpinner";
import { useLogSearchOfURLFilters } from "lib/hooks/api/userActivity/useLogSearch";
import { useCurrentUser } from "lib/hooks/api/users/useCurrentUser";
import { LoggedEntityType } from "lib/types/graphQLEnums";

export function BidsPage() {
  useLogSearchOfURLFilters(LoggedEntityType.Bid, "bidFilters");
  const { data: currentUser } = useCurrentUser();
  const [isLoading] = useState(false);

  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);

  if (isLoading) {
    return <CentredSpinner />;
  }

  return (
    <PageContent>
      <Flex column gap={28} height="100%" width="100%">
        <Flex justifyContent="space-between">
          <Text h1>Bids</Text>
          <Button
            onClick={() => {
              setIsCreateModalOpen(true);
              // TODO: Add tracking here
            }}
            icon="plus"
          >
            Create
          </Button>

          <CreateEntityDrawer
            entityType="bid"
            isOpen={isCreateModalOpen}
            onClose={() => setIsCreateModalOpen(false)}
          >
            <CreateBidForm
              trackingData={{ "Context source": "Bids page" }}
              defaultValues={{ assignedToId: currentUser?.guid }}
              onComplete={() => setIsCreateModalOpen(false)}
            />
          </CreateEntityDrawer>
        </Flex>
        <FilterableBids />
      </Flex>
    </PageContent>
  );
}

const PageContent = styled(DetailsContent)({
  width: "100%",
  paddingTop: "24px",
});
